/**
 * @desc 根据会员ID查询冻结详情
 */
import {
  FreezeRecordDto,
  FreezeRecordQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMemberFreezeRecordParameter = FreezeRecordQuery

const method = 'GET'
const url = '/trade/operation/unfreezeApply/freezeRecord'

export const queryMemberFreezeRecordApi = (
  params?: QueryMemberFreezeRecordParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<FreezeRecordDto>>({
    method,
    url,
    params,
    ...config
  })
}

queryMemberFreezeRecordApi.method = method
queryMemberFreezeRecordApi.url = url
